<template>
    <div class="edit-native-upload-video">
        <!-- <div>
             <small>Допустим формат mp4, размер до 2 мб</small>
        </div> -->
        <video
            controls
            v-if="!loaded && uploaded && uploaded.url"
            ref="videoPlayer"
            class="edit-native-video-player"
            :src="uploaded.url"
        ></video>
        <video controls v-if="loaded && this.video.url.length > 0" ref="videoPlayer" class="edit-native-video-player" :src="this.video.url"></video>
        <br />
        <input type="file" ref="inputVideo" class="hidden" @change="previewVideo" accept="video/mp4" />
        <vs-button class="mt-5 mr-2" color="warning" @click="addVideo()" type="filled"> Загрузить </vs-button>
    </div>
</template>

<script>
import { SweetModal, SweetModalTab } from 'sweet-modal-vue';
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

const maxVideoSize = 2048000;

export default {
    props: {
        uploaded: {},
        campaignId: undefined
    },
    data() {
        return {            
            video: {
                size: undefined,
                name: '',
                data: '',
                url: ''
            },
            loaded: false
        };
    },
    components: {
        SweetModal,
        SweetModalTab,
        VueCropper
    },

    methods: {
        addVideo() {
            this.$refs.inputVideo.click();
        },
        previewVideo: async function (event) {
            var input = event.target;
            if (input.files && input.files[0]) {
                const file = input.files[0];
                const url = URL.createObjectURL(file);
                if (file.type.indexOf('video/mp4') === -1) {
                    return;
                }
                var reader = new FileReader();
                reader.readAsDataURL(file);
                if (file.size > maxVideoSize) {
                    return this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Превышен максимальный размер видео 2МБ',
                        color: 'warning'
                    });
                }
                reader.onload = (e) => {
                    this.video.data = e.target.result;
                    this.video.size = file.size;
                    this.video.name = file.name;
                    this.video.url = url;
                    console.log(this.video);
                };
                this.$refs.inputVideo.value = '';

                this.selectVideo();
            }
        },
        selectVideo() {
            this.loaded = true;
            this.$emit('selectVideo', this.video);
        },
        reset() {
            this.video.size = undefined;
            this.video.name = '';
            this.video.data = '';
            this.video.url = '';
        }
    },
    watch: {},
    computed: {},
    mounted() {}
};
</script>

<style lang="scss">
.edit-native-video-player {
    width: 330px;
}

.edit-native-upload-video
{
    margin-top: 15px;
}
</style>
